"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.shouldSearchLens = exports.errorLens = exports.isFetchingLens = exports.totalResultsLens = exports.companiesLens = exports.searchStringLens = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const actionTypes = require("../../actionTypes/customer/ytj");
exports.searchStringLens = monocle.Lens.fromProp('searchString');
exports.companiesLens = monocle.Lens.fromProp('companies');
exports.totalResultsLens = monocle.Lens.fromProp('totalResults');
exports.isFetchingLens = monocle.Lens.fromProp('isFetching');
exports.errorLens = monocle.Lens.fromProp('error');
exports.shouldSearchLens = monocle.Lens.fromProp('shouldSearch');
//#endregion
exports.initialState = {
    searchString: '',
    isFetching: false,
    companies: [],
    totalResults: 0,
    error: undefined,
    shouldSearch: true
};
const methods = {};
exports.methods = methods;
methods[actionTypes.SEARCH_YTJ_REQUEST] = (state, action) => exports.isFetchingLens.set(true)(state);
methods[actionTypes.SEARCH_YTJ_SUCCESS] = (state, action) => {
    const shouldSearch = action.payload.companies.totalResults > 1000;
    return fp.function.compose(exports.isFetchingLens.set(false), exports.companiesLens.modify((x) => [...x, ...action.payload.companies.list]), exports.totalResultsLens.set(action.payload.companies.totalResults), exports.shouldSearchLens.set(shouldSearch), exports.searchStringLens.set(''))(state);
};
methods[actionTypes.SEARCH_YTJ_FAILED] = (state, action) => fp.function.compose(exports.isFetchingLens.set(false), exports.errorLens.set(action.payload))(state);
methods[actionTypes.SET_YTJ_SEARCH_STRING] = (state, action) => {
    const shouldSearch = action.payload.searchString.length < state.searchString.length
        ? true
        : state.shouldSearch;
    const companies = shouldSearch ? [] : state.companies;
    return fp.function.compose(exports.searchStringLens.set(action.payload.searchString), exports.shouldSearchLens.set(shouldSearch), exports.companiesLens.set(companies))(state);
};
methods[actionTypes.SEARCH_YTJ_CLEAR] = () => (Object.assign({}, exports.initialState));
//# sourceMappingURL=ytj.js.map